const authorListFormat = (authorList, i) => {
    return authorList[i]["name"] + (i != (authorList.length - 1) && i != 6 && "," || "") + (i == 6 && authorList.length > 7 && " et al." || "");
};

export default authorListFormat;